/** @flow */

import * as actions from "@modules/service/constants/actions";
import * as specialContactsReducers from "./reducers";
import initialState from "./state";
import type { SpecialContactsState } from "./types";
import { cloneObject } from "@utils/object";

export default (
  state: SpecialContactsState = initialState,
  action: Object,
): SpecialContactsState => {
  const act = {
    [actions.RemoveSpecialContactType]: specialContactsReducers.onRemoveSpecialContactType,
    [actions.RemoveSpecialContactTypeSuccess]:
      specialContactsReducers.onRemoveSpecialContactTypeSuccess,
    [actions.RemoveSpecialContactTypeError]:
      specialContactsReducers.onRemoveSpecialContactTypeError,

    [actions.AddSpecialContactType]: specialContactsReducers.onAddSpecialContactType,
    [actions.AddSpecialContactTypeSuccess]: specialContactsReducers.onAddSpecialContactTypeSuccess,
    [actions.AddSpecialContactTypeError]: specialContactsReducers.onAddSpecialContactTypeError,

    [actions.AddSpecialContact]: specialContactsReducers.onAddSpecialContact,
    [actions.AddSpecialContactSuccess]: specialContactsReducers.onAddSpecialContactSuccess,
    [actions.AddSpecialContactError]: specialContactsReducers.onAddSpecialContactError,

    [actions.RemoveSpecialContact]: specialContactsReducers.onRemoveSpecialContact,
    [actions.RemoveSpecialContactSuccess]: specialContactsReducers.onRemoveSpecialContactSuccess,
    [actions.RemoveSpecialContactError]: specialContactsReducers.onRemoveSpecialContactError,

    [actions.GetSpecialContacts]: specialContactsReducers.onGetSpecialContacts,
    [actions.GetSpecialContactsSuccess]: specialContactsReducers.onGetSpecialContactsSuccess,
    [actions.GetSpecialContactsError]: specialContactsReducers.onGetSpecialContactsError,

    [actions.UpdateSpecialContact]: specialContactsReducers.onUpdateSpecialContact,
    [actions.UpdateSpecialContactSuccess]: specialContactsReducers.onUpdateSpecialContactSuccess,
    [actions.UpdateSpecialContactError]: specialContactsReducers.onUpdateSpecialContactError,

    [actions.SetSpecialContactsListOptions]:
      specialContactsReducers.onSetSpecialContactsListOptions,
    [actions.SetCurrentSpecialContact]: specialContactsReducers.onSetCurrentSpecialContact,
    [actions.GetSpecialContactsEmployees]: specialContactsReducers.onGetSpecialContactsEmployees,
    [actions.GetSpecialContactsEmployeesSuccess]:
      specialContactsReducers.onGetSpecialContactsEmployeesSuccess,
    [actions.GetSpecialContactsEmployeesError]:
      specialContactsReducers.onGetSpecialContactsEmployeesError,

    [actions.ClearSpecialContactsEmployees]:
      specialContactsReducers.onClearSpecialContactsEmployees,

    [actions.SetShowAddSpecialContactModal]:
      specialContactsReducers.onSetShowAddSpecialContactModal,
    [actions.SetShowEditSpecialContactModal]:
      specialContactsReducers.onSetShowEditSpecialContactModal,
    [actions.SetShowDeleteSpecialContactModal]:
      specialContactsReducers.onSetShowDeleteSpecialContactModal,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
